import { LibraryConfiguration } from "./library-configuration";
import { Handler } from "./handler";
import { BarcodeDimensions } from "./barcode-dimensions";
import { BarcodeStatistics } from "./barcode-statistics";
import { FeeGroup } from "./fee-group";

export class Library {
  constructor(
    public id: number,
    public enabled: boolean,
    public label: string,
    public configuration?: LibraryConfiguration,
    public isLibraryNetworkMember: boolean = false
  ) {}

  public static clone(library: Library): Library {
    return new Library(
      library.id,
      library.enabled,
      library.label,
      library.configuration
        ? LibraryConfiguration.clone(library.configuration)
        : undefined,
      library.isLibraryNetworkMember
    );
  }

  // removed backend db structure
}

